import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
/*import notificationimg from './../../../assets/images/user/user-xs-01.jpg';*/
import Swal from 'sweetalert2';


const Headerdash = ({ toggleSidebar }) => {
    const location = useLocation();
    const [Name, setName] = useState("");  //Add by Jinal
    const [userData, setUserData] = useState({cmsid: "", name: "", email: "", phone: "" });
    const [balance, setBalance] = useState(0); 

     useEffect(() => {
    
      fetchWalletBalance();
      // Listen for balance update events
      const handleWalletUpdate = () => {
        console.log("Received balanceUpdated event.");
      fetchWalletBalance();
     };

      window.addEventListener("balanceUpdated", handleWalletUpdate);

      return () => {
      window.removeEventListener("balanceUpdated", handleWalletUpdate);
    };
  }, []);

  useEffect(() => {            //Below add by Jinal
    const fetchUserProfile = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) return;

            const response = await fetch("https://apiv2.chakran.in/api/UpdateProfile/GetProfile", {
          // const response = await fetch("http://localhost:5121/api/UpdateProfile/GetProfile", {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                console.error("Failed to fetch user profile");
                return;
            }

            const data = await response.json();
            console.log("User Profile Data:", data); // Debugging

            setName(data.name); // Ensure the correct case
            setUserData({
              cmsid:data.cmsid,
              name: data.name,
              email: data.email,
              phone: data.number?.toString() || "", // Ensure phone is a string
            });
        } catch (error) {
            console.error("Error fetching user profile:", error);
        }
    };

    fetchUserProfile();
}, []);


const handleAddMoney = async () => {
  try {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      Swal.fire("Error", "User not authenticated!", "error");
      return;
    }

    // Show a SweetAlert2 input modal
    const { value: amount } = await Swal.fire({
      title: "Enter the amount",
      input: "number",
      inputPlaceholder: "Minimum ₹100",
      inputAttributes: { min: 100 },
      showCancelButton: true,
      confirmButtonText: "Proceed",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value || isNaN(value) || parseFloat(value) < 100) {
          return "Please enter a valid amount of at least ₹100.";
        }
      },
    });

    if (!amount) return; // If the user cancels

    // Open a new window immediately to prevent popup blocking
    const newWindow = window.open("about:blank", "_blank");
    if (!newWindow) {
      Swal.fire("Error", "Popup blocked! Please allow popups and try again.", "error");
      return;
    }

    // Send request to the backend
    const response = await fetch("https://apiv2.chakran.in/api/PayUPayment/add-money", {
    //const response = await fetch("http://localhost:5121/api/PayUPayment/add-money", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: amount,
        productInfo: "WalletRecharge",
        firstName: userData.name,
        email: userData.email,
        phone: userData.phone,
      }),
    });

    const html = await response.text();
    if (response.ok) {
      newWindow.document.open();
      newWindow.document.write(html);
      newWindow.document.close();
    } else {
      newWindow.close();
      Swal.fire("Error", "Failed to initiate payment. Please try again.", "error");
    }
  } catch (error) {
    console.error("Error initiating payment:", error);
    Swal.fire("Error", "An error occurred. Please try again.", "error");
  }
};


const fetchWalletBalance = async () => {
  try {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return;
    const response = await fetch("https://apiv2.chakran.in/api/PayUPayment/get-balance", {
    //const response = await fetch("http://localhost:5121/api/PayUPayment/get-balance", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.error("Failed to fetch wallet balance");
      return;
    }

    const data = await response.json();
    setBalance(data.balance);
  } catch (error) {
    console.error("Error fetching wallet balance:", error);
  }
};


const handleLogout = () => {
  localStorage.removeItem("authToken"); // Clear the token
  window.location.href = "/"; // Force page reload to clear cache
};


   const getPageTitle = () => {
    switch (location.pathname) {
      case '/dashboard':
        return 'Dashboard';
      case '/dashboard/retailers':
        return 'Retailers';
      case '/dashboard/guests':
        return 'Guests';
        case '/dashboard/retailor-transaction-report':
          return 'Retailers Transaction Report';
      case '/dashboard/pay-u-transaction':
        return 'Pay U Transaction';
      case '/dashboard/rise-ticket':
        return 'Rise Ticket';
      case '/dashboard/open-new-ticket':
        return 'Open New Ticket';
      case '/dashboard/close-ticket':
        return 'Close Ticket';
      case '/dashboard/activities':
        return 'Activities';
      case '/dashboard/user-profile':
        return 'User Profile';
      case '/dashboard/chanage-home-content':
        return 'Chanage Home Content';
     
      case '/dashboard/camp-registration':
        return 'Camp Registration';
      case '/dashboard/name-publication':
        return 'Name Publication';
      case '/dashboard/new-pan-application':
        return 'New PAN Application';
      case '/dashboard/correction-pan-application':
        return 'Correction PAN Application';
      case '/dashboard/pan-object':
        return 'PAN Object';
      case '/dashboard/pan-find':
          return 'Find PAN';
      case '/dashboard/add-applicants':
          return 'Add Applicants';

      case '/dashboard/new-pan-application-report':
        return 'New PAN Application Report';
      case '/dashboard/name-publication-report':
          return 'Name Publication report';
      case '/dashboard/camp-registration-report':
        return 'CAMP Registration Report';
      case '/dashboard/pan-object-report':
        return 'PAN Object Report';
      case '/dashboard/pan-find-report':
          return 'PAN Find Report';
      case '/dashboard/correction-pan-application-report':
          return 'Correction PAN Application Report';

      case '/dashboard/new-pan-application-admin-report':
          return 'New PAN Application Admin Report';
      case '/dashboard/correction-pan-application-admin-report':
        return 'Correction PAN Application Admin Report';
      case '/dashboard/name-publication-admin-report':
        return 'Name Publication Admin Report';
      case '/dashboard/pan-object-admin-report':
        return 'PAN Object Admin Report';
      case '/dashboard/camp-registration-admin-report':
        return 'Camp Registration Admin Report';
      case '/dashboard/pan-find-admin-report':
        return 'Pan Find Admin Report';

        case '/dashboard/new-pan-application-complete-report':
          return 'New PAN Application Complete Report';
      case '/dashboard/correction-pan-application-complete-report':
        return 'Correction PAN Application Complete Report';
      case '/dashboard/name-publication-complete-report':
        return 'Name Publication Complete Report';
      case '/dashboard/pan-object-complete-report':
        return 'PAN Object Complete Report';
      case '/dashboard/camp-registration-complete-report':
        return 'Camp Registration Complete Report';
      case '/dashboard/pan-find-complete-report':
        return 'Pan Find Complete Report';

      default:
        return 'Dashboard'; // Default title if no match
    }
  };
  return (
    <header className="main-header" id="header">
      <nav className="navbar navbar-expand-lg navbar-light" id="navbar">
        <button id="sidebar-toggler" className="sidebar-toggle" onClick={toggleSidebar}>
          <span className="sr-only">Toggle navigation</span>
        </button>
        <span className="page-title">{getPageTitle()}</span>
        <div className="navbar-right ">
          <div className="search-form">
            <div className="media">
            <i className="display-6 mdi mdi-account-card-details text-primary mr-3"></i>
                            <div className="media-body mr-2">
                                <p>CMS ID</p>
                                <p className="h5 my-1 text-dark">{userData.cmsid}</p>
                            </div>
              <i className="display-6 mdi mdi-currency-inr text-primary mr-3"></i>
              <div className="media-body mr-2">
                <p>Balance</p>
                <p className="h5 my-1 text-dark"> ₹{balance}</p>
                  {/* <span className="text-success"> <i className="mdi mdi-refresh small"></i></span></p> */}
                  <button onClick={fetchWalletBalance} className="btn btn-link p-0">
                    <i className="mdi mdi-refresh small"></i>
                  </button>
                
              </div>
              <div className="wallet-controls mt-3">
              <button className="btn btn-primary mb-2 btn-pill" onClick={handleAddMoney}>
                  Add <i className="mdi mdi-currency-inr"></i>
              </button>
            
              </div>
            </div>
           
            {}
          </div>
          <ul className="nav navbar-nav">
            {}
            <li className="dropdown user-menu">
              <button className="dropdown-toggle nav-link" data-toggle="dropdown">
                <span className="d-none d-lg-inline-block">{Name}</span>
              </button>
              <ul className="dropdown-menu dropdown-menu-right">
                <li>
                  <Link className='dropdown-link-item' to='/dashboard/user-profile'>
                    <i className="mdi mdi-account-outline"></i>
                    <span className="nav-text">My Profile</span>
                  </Link>
                </li>
                <li className="dropdown-footer">
                  <Link className='dropdown-link-item' to="/" onClick={handleLogout}> <i className="mdi mdi-logout"></i> Log Out </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Headerdash;
